import Text from '@deprecated-ui/common/Text';
import IconBase64 from '@deprecated-ui/common/IconBase64';
import Button from '@deprecated-ui/common/Button';
import { useDispatch, useSelector } from 'react-redux';
import GoogleLogin from 'react-google-login';
import { clevertapEvent } from 'utils/clevertap';
import { googleIcon, newGoogleIcon } from 'assets/base64icon';
import AuthButtonView from '../AuthButton';
import { effects, selectors } from './slice';
import { registerTypes } from '../constants';

const googleClientId = process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID;

function GoogleOauth({
  variant = 'main',
  size = 'large',
  isCompanyStock = false,
}) {
  const dispatch = useDispatch();
  const { isLoading } = useSelector(selectors);
  const textButton = 'Register with Google';

  const onCallClevertapEvent = () => {
    clevertapEvent('Register Selected', {
      'Register Method': registerTypes.GOOGLE,
    });
  };

  const handleOauthCallback = (response: any) => {
    if (!response.error) {
      dispatch(effects.generateUsername(response));
    }
  };

  const renderMainButton = (
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void,
  ) => (
    <Button
      id="google-register"
      height="44px"
      // @ts-expect-error
      mt="10px"
      loading={isLoading}
      block
      onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
        onCallClevertapEvent();
        onClick(e);
      }}
    >
      <AuthButtonView
        iconUrl="/icon/register/icon-google.svg"
        text={textButton}
        isFilled
      />
    </Button>
  );

  const renderSecondaryButton = (
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void,
  ) => {
    const buttonHeight = `${size === 'medium' ? 30.8 : 44}px`;
    const iconSize = `${size === 'medium' ? 16.8 : 24}px`;
    const fontSize = `${size === 'medium' ? 9.8 : 14}px`;
    const icon = isCompanyStock ? newGoogleIcon : googleIcon;
    const iconPadding = isCompanyStock ? '10px' : 'unset';

    return (
      <Button
        block
        // @ts-expect-error
        round
        mb="16px"
        height={buttonHeight}
        justifyContent="start"
        loading={isLoading}
        id="google-register"
        style={{ paddingLeft: 20, paddingRight: 20 }}
        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
          onCallClevertapEvent();
          onClick(e);
        }}
      >
        <IconBase64 icon={icon} iconSize={iconSize} padding={iconPadding} />
        <Text
          color="light"
          size={fontSize}
          family="bold"
          width="100%"
          align="center"
        >
          {textButton}
        </Text>
      </Button>
    );
  };

  return (
    <GoogleLogin
      clientId={googleClientId}
      buttonText="Register"
      onSuccess={handleOauthCallback}
      onFailure={handleOauthCallback}
      cookiePolicy="single_host_origin"
      className="register-with-google-button hide"
      render={({ onClick }) => {
        if (variant === 'secondary') {
          return renderSecondaryButton(onClick);
        }

        return renderMainButton(onClick);
      }}
    />
  );
}

export default GoogleOauth;
